import { selectBackgroundOptions } from "@/store/canvas/canvasSelectors";
import { setBackgroundOptions } from "@/store/canvas/canvasSlice";
import { useDispatchChangeBackgroundOptionsEvent } from "./event/useChangeBackgroundOptionsEvent";
import { useDispatch, useSelector } from "react-redux";

export function useBackgroundOptions() {
  const dispatch = useDispatch();
  const dispatchChangeBackgroundOptionsEvent = useDispatchChangeBackgroundOptionsEvent();
  const backgroundOptions = useSelector(selectBackgroundOptions);

  return {
    backgroundOptions,
    dispatchChangeBackgroundOptionsEvent,
    updateBackgroundOptions,
    updateBackgroundOptionsAndDispatchChangeBackgroundOptionsEvent,
  };

  function updateBackgroundOptions(options: Partial<typeof backgroundOptions>) {
    if (!backgroundOptions) return;

    dispatch(setBackgroundOptions({ ...backgroundOptions, ...options }));
  }

  function updateBackgroundOptionsAndDispatchChangeBackgroundOptionsEvent(options: Partial<typeof backgroundOptions>) {
    if (!options) return;

    dispatchChangeBackgroundOptionsEvent(options);
    updateBackgroundOptions(options);
  }
}
